import {connect} from 'react-redux'
import {getProp} from '../../../../../../redux/selectors/kegCollectionBookings'

import ModalErrorBanner from './BookingsModalErrorBanner'

const mapStateToProps = state => {
  const {bookingsModalErrorBannerState} = getProp(state)

  return {
    isShowing: bookingsModalErrorBannerState.isShowing,
    header: bookingsModalErrorBannerState.header,
    content: bookingsModalErrorBannerState.content,
  }
}

export default connect(mapStateToProps)(ModalErrorBanner)
